import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'home',
    component: () => import(/* webpackChunkName: "about" */ '@/layout/index.vue'),

    children: [
      {
        path: '/history',
        name: 'history',

        component: () => import(/* webpackChunkName: "about" */ '@/components/history/index.vue')
      },
      {
        path: '/warning',
        name: 'warning',

        component: () => import(/* webpackChunkName: "about" */ '@/components/warning/index.vue')
      },
      {
        path: '/warningYd',
        name: 'warningYd',

        component: () => import(/* webpackChunkName: "about" */ '@/components/warningYd/index.vue')
      }
    ]
  },
  {
    path: '/home',
    name: 'home',

    component: () => import(/* webpackChunkName: "about" */ '@/layout/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '@/components/login/index.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
